export default __webpack_public_path__ + "static/media/3.50ecc32d.png";